<template>
  <div class="oi-external-en-form" :class="'lang-'+lang">
    <Thanks v-if="step === 'thanks'" />
    <Error v-else-if="step === 'error'" />
    <Finalize v-else-if="step === 'finalize'" />
    <div v-else>
      <ExternalEnForm v-if="page === 'form'"/>
      <UnsubscribeForm v-if="page === 'unsubscribe'" />
      <ChangeSubscriptionForm v-if="page === 'changeSubscription'" />
      <FormFooter v-if="footer" @switchPage="changePage" :page="page" />
      <Overlay v-if="showOverlay" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormFooter from './FormFooter.vue'
import ExternalEnForm from './ExternalEnForm.vue'
import ChangeSubscriptionForm from '@/components/change-subscription-form/ChangeSubscriptionForm.vue'
import UnsubscribeForm from '@/components/unsubscribe-form/UnsubscribeForm.vue'
import Thanks from '@/components/shared/Thanks.vue'
import Error from '@/components/shared/Error.vue'
import Finalize from '@/components/shared/Finalize.vue'
import Overlay from '@/components/shared/Overlay.vue'
import { LABELS } from '@/settings'

export default {
  components: { ChangeSubscriptionForm, UnsubscribeForm, FormFooter, ExternalEnForm, Overlay, Thanks, Error, Finalize },
  computed: mapState({
    page: state => state.page,
    step: state => state.step,
    showOverlay: state => (state.step === 'precheckout' || state.step === 'checkout') && state.checkoutType !== 'popup' && state.checkoutType !== 'widget',
    header: state => state.header,
    footer: state => state.footer,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    changePage: function (page) {
      this.state.page = page
    }
  }
}
</script>

<style>
  .oi-external-en-form {
    font-family: CoFo Sans;
    position: relative;
    padding: 10px;
    max-width: 400px;
    background: #fff;
    user-select: none;
  }
  .oi-external-en-form input[type='text'],
  .oi-external-en-form input[type='email'],
  .oi-external-en-form input[type='number']:not(.other-sum),
  .oi-external-en-form textarea {
    font-family: CoFo Sans;
    font-size: 15px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0em;
    background-color: #EFF2F3!important;
    border-radius: 0!important;
    border: 1px solid #EFF2F3!important;
    padding: 6px 18px!important;
    margin-bottom: 10px;
    transition: .3s cubic-bezier(0,0,0,1);
  }
  .oi-external-en-form input[type='text'],
  .oi-external-en-form input[type='email'],
  .oi-external-en-form input[type='number']:not(.other-sum) {
    height: 43px!important;
  }
  .oi-external-en-form textarea {
    padding: 18px!important;
    resize: vertical;
  }
  .oi-external-en-form input[type='text']::placeholder,
  .oi-external-en-form input[type='email']::placeholder,
  .oi-external-en-form input[type='number']:not(.other-sum)::placeholder,
  .oi-external-en-form textarea::placeholder {
    color: #ABBCC1;
  }
  .oi-external-en-form input[type='text']:focus,
  .oi-external-en-form input[type='email']:focus,
  .oi-external-en-form input[type='number']:not(.other-sum):focus,
  .oi-external-en-form textarea:focus {
    border: 1px solid #FF6F37!important;
  }
  .oi-external-en-form input {
    margin-bottom: 10px;
  }
  .oi-external-en-form small.help {
    margin: 0 0 12px!important;
  }
  .oi-external-en-form small.help.error {
    color: #FF6F37!important;
  }
  .oi-donate .oi-external-en-form .donate {
    height: 58px;
    background-color: #FF6F37!important;
    border: 1px solid #FF6F37!important;
    font-family: CoFo Sans;
    font-size: 30px;
    font-weight: 900;
    line-height: 30px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    border-radius: 0;
    transition: .3s cubic-bezier(0,0,0,1);
  }
  .oi-donate .oi-external-en-form .donate:hover {
    color: #FF6F37!important;
    border: 1px solid #FF6F37!important;
  }
  .oi-donate .oi-external-en-form .change-subscription-form,
  .oi-donate .oi-external-en-form .unsubscribe-form {
    border: none;
  }
</style>
